/**
 * Created by Mattias on 2014-10-22.
 */
define('payment/handlers/sendHandlers/pendingAfterSingleCallHandler',['jquery', 'boxes/events/paymentEvent', 'boxes/helpers/box-loading'],

    function($, paymentEvent, boxLoading) {
        'use strict';

        var methodName;

        function init(methodNameIn) {
            methodName = methodNameIn;
        }

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {
            boxLoading.removeLoading(paymentBox.$box);
            var parameterMap = sendHandlerData.parameterMap;
            paymentBox.$controller.trigger(paymentEvent.PENDING, parameterMap);

            window.top.getPaymentResult.getSynchronousDepositResultAndShowFinalResult(accHistRef, paymentFetchResultFlow, function(data) {
                paymentBox.$controller.trigger(paymentEvent.AMOUNT_IN_TRANSACTION, data.amount);
                paymentBox.$controller.nextBox();
            });
        }

        function cleanupOnFail() {}

        var pendingAfterSingleCallHandler = {};
        pendingAfterSingleCallHandler.init = init;
        pendingAfterSingleCallHandler.handleSuccessfulResponse = handleSuccessfulResponse;
        pendingAfterSingleCallHandler.cleanupOnFail = cleanupOnFail;

        return pendingAfterSingleCallHandler;
    }
);

